import React from "react";
import "./Projects.css";
import zoomcar from "../imgss/zoomcar.png"
import times from "../imgss/times.png"
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section" style={{marginTop:"100px"}}>
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
              </div>
              <div className="project_information">
                <h2>Solar Panel micro-services for USA customers.</h2>
                <p>
                Database - PostgreSQL + MongoDB, framework- Spring-boot, Spring
Security, Micro-services, Builder- Jenkins<br />
Role - 1. Resolved bugs across production, UAT, QA, and Dev environments
for all 12 operational services integrated with the React framework.<br />
2. Independently crafted a security service for the application, ensuring a
robust and secure system.<br />
3. Developed architecture and unit tests for all 12 services, ensuring robust
and reliable performance.<br />
4. Engaged with the CEO and Scrum branch head, comprehensively
grasping the business challenge and consistently delivering high-quality
solutions each sprint.<br />
User base - USA customers only
                </p>
                <div>
                </div>
                
              </div>
            </div>
          </div>
          
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                
              </div>
              <div className="project_information">
                <h2>SIM Online billing Engine (micro-services)</h2>
                <p>
                Database - MySql, framework- Spring-boot, Builder- Docker, AWS<br />
Role - 1. Executed a seamless implementation of graceful shutdown
procedures for all services. <br />
2. Deployed Hazelcast caching strategically for optimal performance.<br />
3. Collaborated closely with the Engineering head to tailor the application<br />
to meet specific client requirements, ensuring seamless customization
and client satisfaction.<br />
User base - 25 Million active users
                </p>
                <div>
                </div>
                
              </div>
            </div>
          </div>

         
          
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                
              </div>
              <div className="project_information">
                <h2>Online Pizza delivery application</h2>
                <p>
                Database - MongoDB, Framework- Spring-boot, builder- docker, AWS<br />
Role- Single Handly created the whole project from scratch writing
Every line of code with J Unit5 testing.
User base- In the development phase.
                </p>
                <div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
